import { actions } from '../../utils/constants';

export const enrollUser = (data) => ({
    type: actions.ASYNC_ENROLL_USER,
    payload: data,
});

export const enrollUserFromRegisterNewUser = (data) => ({
    type: actions.ASYNC_ENROLL_USER_FROM_REGISTER_NEW_USER,
    payload: data,
});

export const unenrollUser = (data) => ({
    type: actions.ASYNC_UNENROLL_USER,
    payload: data,
});

export const updateEnrollment = (classId, userId, data) => ({
    type: actions.ASYNC_UPDATE_ENROLLMENT,
    payload: {
        classId,
        userId,
        data,
    },
});



// WEBPACK FOOTER //
// ./src/components/admin/admin.actions.js